export default "__VITE_ASSET__DCbYtqjO__"